/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Sign_InInputs */

const cs_nav_sign_in = /** @type {(inputs: Nav_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přihlásit se`)
};

const sk_nav_sign_in = /** @type {(inputs: Nav_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prihlásiť sa`)
};

const en_nav_sign_in = /** @type {(inputs: Nav_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in`)
};

/**
* | output |
* | --- |
* | "Sign in" |
*
* @param {Nav_Sign_InInputs} inputs
* @param {{ locale?: "cs" | "sk" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_sign_in = /** @type {((inputs?: Nav_Sign_InInputs, options?: { locale?: "cs" | "sk" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Sign_InInputs, { locale?: "cs" | "sk" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "cs") return cs_nav_sign_in(inputs)
	if (locale === "sk") return sk_nav_sign_in(inputs)
	return en_nav_sign_in(inputs)
});